import Typography from "@mui/material/Typography";
import StudiengangSelector from "@/components/StudiengangSelector";
import UniversityDegreeSelector from "@/components/UniversityDegreeSelector";

const NetworkLocationFormHochschulen = ({onChange}) => {

    const handleInputChanged = (event, value) => {
        if (onChange && typeof onChange === "function") {
            onChange(event, value);
        }
    }

    const handleCheckboxChanged = (event) => {
        event.target.value = event.target.checked;

        if (onChange && typeof onChange === "function") {
            onChange(event);
        }
    };

    return (
        <>
            <Typography variant="h4" component="p" color="common.black" sx={{ mt: 4,}}>
                Orts-spezifische Angaben (Hochschulen)
            </Typography>
            <StudiengangSelector onChange={handleInputChanged} />
            <UniversityDegreeSelector name="degrees" onChange={handleInputChanged} />
        </>
    )
}

export default NetworkLocationFormHochschulen;
